import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { EmployeeAutomaticMessageItem } from 'src/app/shared/models/EmployeeAutomaticMessage.item';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { Job } from 'src/app/shared/models/focusDataModels/Job';
import { TimecardRecord } from 'src/app/shared/models/TimecardRecord.model';

@Component({
	selector: 'app-automatic-employee-message-single',
	templateUrl: './automatic-employee-message-single.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class AutomaticEmployeeMessageSingleComponent implements OnInit {
	changesToSave: boolean = false;
	message: EmployeeAutomaticMessageItem;

	jobList: Job[] = [];

	enableSpanishContent: boolean = false;
	enableFrenchContent: boolean = false;

	historyLoaded: boolean = false;

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		private focuslink: FocuslinkService,
		private router: Router,
		private activatedRoute: ActivatedRoute
	) {}

	ngOnInit(): void {
		const messageSkOrIntent = this.activatedRoute.snapshot.paramMap.get('messageSk');
		if (messageSkOrIntent === 'newmessage') {
			this.message = new EmployeeAutomaticMessageItem();
		} else {
			this.message = this.venueService.automaticEmployeeMessageList.value.find((i) => i.sk === messageSkOrIntent);
			(this.message.subjectSpanish || this.message.contentSpanish) && (this.enableSpanishContent = true);
			(this.message.subjectFrench || this.message.contentFrench) && (this.enableFrenchContent = true);

			this.matchTimecardIdToHistory();
		}

		this.jobList = [
			new Job({
				name: 'All jobs',
				id: 999,
			}),
		];
		this.jobList = this.jobList.concat(this.venueService.jobList.value);
	}

	async getMessage(venueKey: number, messsageSk: string): Promise<EmployeeAutomaticMessageItem> {
		this.app.loading(true);
		const resp = await this.focuslink.employeeAutoMessageGetOne(venueKey, messsageSk);
		this.message = new EmployeeAutomaticMessageItem(resp);
		this.app.loading(false);
		return this.message;
	}

	async matchTimecardIdToHistory() {
		const taskList = [];
		this.message.timecardIdHistory?.forEach((timecardHistory) => {
			taskList.push(this.getRelatedTimecardId(timecardHistory.timecardId).then((data) => (timecardHistory.timecard = data)));
		});
		await Promise.all(taskList);

		this.historyLoaded = true;
	}

	async getRelatedTimecardId(timecardId: string): Promise<TimecardRecord> {
		try {
			const resp = await this.focuslink.timecardRecordGetOne(this.venueService.subscriptionVenue.value.key, timecardId);
			return new TimecardRecord(resp);
		} catch (error) {
			console.log(error);
		}
	}

	back() {
		this.router.navigate(['cc/communication/automessages']);
	}

	async delete() {
		await this.focuslink.employeeAutoMessageDelete(this.venueService.subscriptionVenue.value.key, this.message.sk);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `Employee message deleted successfully.` });
		this.back();
	}

	async save() {
		this.app.loading(true);
		let resp;
		if (this.message.sk) {
			resp = await this.focuslink.employeeAutoMessagePatch(this.venueService.subscriptionVenue.value.key, this.message);
		} else {
			resp = await this.focuslink.employeeAutoMessagePost(this.venueService.subscriptionVenue.value.key, this.message);
		}
		this.message = new EmployeeAutomaticMessageItem(resp);
		(this.message.subjectSpanish || this.message.contentSpanish) && (this.enableSpanishContent = true);
		(this.message.subjectFrench || this.message.contentFrench) && (this.enableFrenchContent = true);
		this.changesToSave = false;
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `Employee message saved successfully.` });
		this.app.loading(false);
	}

	validateFor(func: string): boolean {
		switch (func) {
			case 'save':
				if (
					!this.message.hoursWorkedEnd ||
					!this.message.hoursWorkedStart ||
					!this.message.subjectEnglish ||
					!this.message.contentEnglish ||
					!this.message.jobId ||
					!this.changesToSave
				) {
					return false;
				}
				return true;
			case 'delete':
				if (!this.message.sk) {
					return false;
				}
				return true;
				break;
		}

		return true;
	}
}
